import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import AggregateController from "csi/heading/AggregateController";
import locale from "csi/locale";
import MessageDialog from "csi/widget/MessageDialog";
import PostRequest from "csi/comm/PostRequest";
import xml from "csi/xml";

const SelectShape = declare(AggregateController, {

	bHold: false,

	hasToConfirmAction() {
		return true;
	},

	confirmAction(params: Object) {
		this.preProcess();
	},

	/**
	 * According to the service response we set and build the warning message
	 */
	_onValidateResponse(response: any) {
		if (response.getReturnValue()) {
			this._confirm("WARNING", "Style", "RemoveShapeFromStyle_Confirm");
		} else {
			this._confirm("WARNING", "Style", "RemoveShapeFromStyleNoLinked_Confirm");
		}
	},


	/**
	 * this function is used to call the service to validate the links with shape and style
	 * and show the warning message according to the validation rules.
	 */
	publish() {
		const urlOld = this.oldValue;
		const urlNew = this.newValue;
		if (!this._bPopup && xml.isValidURL(urlOld as string) && urlNew != urlOld) {
			this.setProgress();
			new PostRequest("ProductSpec", "ValidateShapeStyleDS")
				.addParameter(xml.PROP_URL_PARENT, this.m_urlNode)
				.post({})
				.then(lang.hitch(this, this._onValidateResponse));
		} else {
			this.inherited(arguments);
		}
	},

	/**
	 * Execute the actions acording to the action button selected by the user
	 */
	onConfirm(key: string) {
		if (key == MessageDialog.BUTTON_YES) {
			AggregateController.prototype.publish.call(this);
		} else {
			this.postProcess();
		}
	},

	/**
	 * Build the pop up warning message with the buttons
	 */
	_confirm(titleKey: string, messageKey: string, localeMsg: string) {
		AggregateController.prototype.confirmAction.call(this, {
			materialIcon: MessageDialog.ICON_WARNING,
			title: locale.resource(titleKey),
			buttons: [MessageDialog.BUTTON_YES, MessageDialog.BUTTON_CANCEL],
			message: locale.typeAction(messageKey, localeMsg),
		});
	},

});

export = SelectShape;
